import React, { useState, useEffect } from "react";
import "./program.css";
import { getPastPrograms } from "./programsData";

const PastPrograms = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [pastPrograms, setPastPrograms] = useState([]);
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const programs = getPastPrograms();
    console.log("Fetched past programs:", programs);
    setPastPrograms(programs);
    setFilteredPrograms(programs);
  }, []);

  // Live search filtering
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredPrograms(pastPrograms);
    } else {
      const filtered = pastPrograms.filter((program) => {
        const searchLower = searchTerm.toLowerCase();
        return (
          program.name.toLowerCase().includes(searchLower) ||
          program.courseCoordinator.toLowerCase().includes(searchLower)
        );
      });
      setFilteredPrograms(filtered);
    }
  }, [searchTerm, pastPrograms]);

  const handleCardClick = (program) => {
    setSelectedImage(program.image);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm("");
  };

  console.log("Rendering with filtered programs:", filteredPrograms);

  return (
    <div className="conference-schedule">
      <div className="conference-schedule-container">
        <div className="conference-highlight">
          <div className="flyers-container">
            <h3>Past Events</h3>

            {/* Search Bar */}
            {pastPrograms.length > 0 && (
              <div className="search-container">
                <div className="search-input-wrapper">
                  <input
                    type="text"
                    placeholder="Search by event name or course coordinator..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="search-input"
                  />
                  {searchTerm && (
                    <button
                      onClick={clearSearch}
                      className="search-clear-btn"
                      title="Clear search"
                    >
                      ×
                    </button>
                  )}
                </div>
                <div className="search-info">
                  {searchTerm && (
                    <p className="search-results-text">
                      {filteredPrograms.length === 0
                        ? "No events found"
                        : `Found ${filteredPrograms.length} event${
                            filteredPrograms.length === 1 ? "" : "s"
                          }`}
                      {searchTerm && ` matching "${searchTerm}"`}
                    </p>
                  )}
                </div>
              </div>
            )}

            {pastPrograms.length === 0 ? (
              <div className="no-events">
                <p>No past events to display.</p>
              </div>
            ) : filteredPrograms.length === 0 && searchTerm ? (
              <div className="no-events">
                <p>No events found matching "{searchTerm}"</p>
                <button onClick={clearSearch} className="clear-search-button">
                  Clear search to see all events
                </button>
              </div>
            ) : (
              <div className="past-programs-grid">
                {filteredPrograms.map((program) => (
                  <div
                    key={program.id}
                    className="past-program-card"
                    onClick={() => handleCardClick(program)}
                  >
                    <div className="program-info">
                      <h4 className="program-name">{program.name}</h4>
                      <p className="program-coordinator">
                        <strong>Course Coordinator:</strong>{" "}
                        {program.courseCoordinator}
                      </p>
                      <p className="program-fee">
                        <strong>Registration Fee:</strong> RS{" "}
                        {program.registrationFee}
                      </p>
                      <p className="program-date">
                        <strong>Date:</strong> {formatDate(program.endDate)}
                      </p>
                    </div>
                    <div className="view-flyer-btn">View</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal-overlay" onClick={handleCloseImageModal}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-modal-close"
              onClick={handleCloseImageModal}
            >
              &times;
            </button>
            <div className="image-container">
              <img
                src={selectedImage}
                alt="Program Flyer"
                className="modal-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PastPrograms;
